import "../css/index.scss";

import "core-js/es/array";

import $ from "jquery/dist/jquery";
// needs to be set BEFORE boostrap 3
window.jQuery = window.$ = $;

import "jquery.transit/jquery.transit";
import "slick-carousel/slick/slick.js";

//import "bootstrap/dist/js/bootstrap";

import "@nxcms/nxcms-js/src/js/sentry";

import "@nxcms/nxcms-js/src/js/static/bootstrap_3";
import "@nxcms/nxcms-js/src/js/static";
import "@nxcms/nxcms-js/src/js/blog";

import "@nxcms/nxcms-js/src/js/eshop";
import "@nxcms/nxcms-js/src/js/eshop/60_price_history_optional";

import "@nxcms/nxcms-js/src/js/ga4-eec";
import "@nxcms/nxcms-js/src/js/gallery";

import "@nxcms/nxcms-js/src/js/search";

import "@nxcms/nxcms-js/src/js/delivery-zasilkovna";
import "@nxcms/nxcms-js/src/js/delivery-balikobot-pickup";
import "@nxcms/nxcms-js/src/vue-component/balikobot-pickup";

import "@nxcms/nxcms-js/src/js/gdpr";

import "./99_newsletterform.js";
import "./99_partner_slide.js";
import "./99_searchform.js";
import "./99_smoothscroll.js";

$(function () {
  $(".cart-continue-btn").click(function () {
    $("#setDeliveryInfoForm").submit();
  });
});
